const privacyPolicyOverride = `
  <p>At Ridge &amp; Harbor, we collect and use personal information in order to operate our storefront, process orders, provide customer support, and improve the shopping experience. This Privacy Policy explains what information we collect, how we use it, and the choices available to you.</p>

  <h2>Information We Collect</h2>
  <p>We may collect information you provide directly to us, including your name, email address, billing details, shipping details, and any information you share when contacting our team.</p>
  <p>We may also collect technical and usage information such as browser type, device information, IP address, referral information, and how you interact with the site.</p>

  <h2>How We Use Information</h2>
  <ul>
    <li>To process orders, payments, shipping, and returns</li>
    <li>To communicate with you about purchases, service requests, or support questions</li>
    <li>To maintain, improve, and secure the storefront</li>
    <li>To analyze site usage and improve merchandising and customer experience</li>
    <li>To comply with legal obligations and prevent fraud or misuse</li>
  </ul>

  <h2>Sharing of Information</h2>
  <p>We may share information with service providers that help us run the store, including ecommerce infrastructure, payments, shipping, analytics, and customer support tools. We may also share information if required by law or when reasonably necessary to protect our business, customers, or rights.</p>

  <h2>Cookies and Analytics</h2>
  <p>Like many online stores, we may use cookies and similar technologies to keep the site functioning properly, remember preferences, support cart and checkout features, and understand how visitors use the site.</p>

  <h2>Your Choices</h2>
  <p>You may request access to, correction of, or deletion of personal information we control, subject to applicable law. You may also opt out of marketing emails by using the unsubscribe link included in those messages.</p>

  <h2>Data Retention</h2>
  <p>We retain information for as long as needed to operate the store, provide service, maintain business records, resolve disputes, and comply with applicable legal requirements.</p>

  <h2>Updates to This Policy</h2>
  <p>We may update this Privacy Policy from time to time to reflect operational, legal, or business changes. The most current version will always be posted on this page.</p>

  <h2>Contact</h2>
  <p>If you have questions about this Privacy Policy or how we handle personal information, please visit our <a href="/pages/contact">contact page</a> to start a conversation.</p>
`;

function forceInteractorSidebarMode() {
  const flag = '__ridgeHarborSidebarMode';

  const wrapInitialize = (interactor, initialize) => {
    if (typeof initialize !== 'function' || initialize[flag]) return initialize;

    const wrappedInitialize = (interactorId, options = {}) => initialize.call(interactor, interactorId, {
      ...options,
      type: 'sidebar',
    });

    Object.defineProperty(wrappedInitialize, flag, {
      value: true,
      configurable: false,
    });

    return wrappedInitialize;
  };

  const prepareInteractor = (interactor) => {
    if (!interactor || interactor[flag]) return interactor;

    let currentInitialize = wrapInitialize(interactor, interactor.initialize);

    try {
      Object.defineProperty(interactor, 'initialize', {
        configurable: true,
        get() {
          return currentInitialize;
        },
        set(nextInitialize) {
          currentInitialize = wrapInitialize(interactor, nextInitialize);
        },
      });

      Object.defineProperty(interactor, flag, {
        value: true,
        configurable: false,
      });
    } catch (error) {
      interactor.initialize = wrapInitialize(interactor, interactor.initialize);
    }

    return interactor;
  };

  let currentInteractor = prepareInteractor(window.interactor);

  try {
    Object.defineProperty(window, 'interactor', {
      configurable: true,
      get() {
        return currentInteractor;
      },
      set(nextInteractor) {
        currentInteractor = prepareInteractor(nextInteractor);
      },
    });
  } catch (error) {
    prepareInteractor(window.interactor);
  }
}

forceInteractorSidebarMode();

function overridePrivacyPolicyContent() {
  if (!window.location.pathname.includes('/policies/privacy-policy')) return;

  const policyTitle = document.querySelector('.shopify-policy__title h1');
  const policyBody = document.querySelector('.shopify-policy__body');

  if (policyTitle) {
    policyTitle.textContent = 'Privacy Policy';
  }

  if (policyBody) {
    policyBody.innerHTML = privacyPolicyOverride;
  }
}

overridePrivacyPolicyContent();

document.addEventListener('click', (event) => {
  const menuToggle = event.target.closest('[data-mobile-menu-toggle]');
  const menuClose = event.target.closest('[data-mobile-menu-close]');
  const drawer = document.querySelector('[data-mobile-drawer]');

  if (menuToggle && drawer) {
    drawer.classList.add('is-open');
    document.body.classList.add('rh-menu-open');
  }

  if (menuClose && drawer) {
    drawer.classList.remove('is-open');
    document.body.classList.remove('rh-menu-open');
  }

  const conciergeTrigger = event.target.closest('[data-concierge-message]');

  if (conciergeTrigger) {
    const message = conciergeTrigger.getAttribute('data-concierge-message');
    if (drawer) {
      drawer.classList.remove('is-open');
      document.body.classList.remove('rh-menu-open');
    }

    if (message && window.interactor?.message?.send) {
      window.interactor.message.send(message, { shouldOpenChat: true });
      return;
    }

    if (window.interactor?.modal?.open) {
      window.interactor.modal.open();
    }
  }
});

document.addEventListener('keyup', (event) => {
  if (event.key !== 'Escape') return;
  const drawer = document.querySelector('[data-mobile-drawer]');
  if (drawer) drawer.classList.remove('is-open');
  document.body.classList.remove('rh-menu-open');
});
